import { useContext, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { FormContextMA } from "../form-context";
import { DataField, Divider, H2, Section } from "./common-components";
import Signature from "../../common/signature/Signature";
import { formatToYYYY_MMM_DD } from "../../../helpers/functions";
import { getCurrentUserDetails } from "../../../redux/modules/user/actions";

export const ConsentInformation = ({formType, patient, preAssessment, startDateTime}) => {
  // const { patient, preAssessment, startDateTime } = useContext(FormContextMA);
  // const {} = useContext(FormContextMA);
  
  const { currentLoggedInUserDetail } = useSelector((state) => state.currentLoggedInUserDetail);
  const usersState = useSelector((state) => state.users);
  const dispatch = useDispatch();

  // Helper to compute pharmacist full name once
  const getFullName = (u) => (u?.firstName && u?.lastName ? `${u.firstName} ${u.lastName}` : null);
  const pharmacistName =
    getFullName(currentLoggedInUserDetail) ??
    getFullName(usersState?.currentLoggedInUserDetail) ??
    "-";

  // Helper to format signature URL
  const getSignatureUrl = (u) => {
    if (!u?.signature || typeof u.signature !== 'string' || u.signature.length === 0) return null;
    return u.signature.startsWith('data:') ? u.signature : `data:image/png;base64,${u.signature}`;
  };
  const pharmacistSignature =
    getSignatureUrl(currentLoggedInUserDetail) ??
    getSignatureUrl(usersState?.currentLoggedInUserDetail) ??
    null;

  // Fetch user details if not available
  useEffect(() => {
    if (!currentLoggedInUserDetail) {
      const userInfo = JSON.parse(sessionStorage.getItem('userInfo') || '{}');
      const userId = userInfo.userId;
      
      if (userId) {
        dispatch(getCurrentUserDetails(userId, false));
      }
    }
  }, [currentLoggedInUserDetail, dispatch]);

  return (
    <Section formType = {formType}>
      <div className="grid grid-cols-3">
        <H2 className="">Consent Information</H2>
        <div />
        <DataField label="Date Obtained" value={formatToYYYY_MMM_DD(startDateTime)} />
      </div>
      <DataField label="Patient Consent Name" value={patient?.lastName + " " + patient?.firstName}/>
      <div className="flex flex-row gap-2 ">
        <DataField
          label="Patient Verbal/Signature Consent"
          
        />
        <Signature forDocument={true} firstName={preAssessment?.patientSignature} />
      </div>
      <Divider />
      <DataField 
        label="Pharmacist Acknowledgment /Consent Name" 
        value={currentLoggedInUserDetail?.name || usersState?.currentLoggedInUserDetail?.name || pharmacistName}
      />
      <div className="flex flex-row gap-2">
        <DataField
          label="Pharmacist Verbal/Signature Consent"
        />
        {pharmacistSignature && (
          <div className="flex items-center">
            <img
              src={pharmacistSignature}
              alt="Pharmacist Signature"
              className="inline-block max-h-[40px] max-w-[200px] object-contain align-middle -mt-2"
            />
          </div>
        )}
      </div>
    </Section>
  );
};
